import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography, useMediaQuery, Tab, Tabs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import Skeleton from '@mui/material/Skeleton';
import Rating from '@mui/material/Rating';
import { createTheme } from '@mui/material/styles';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PlayCircleFilledOutlined, StarOutlineRounded, PlayCircleOutlineOutlined, StarBorder, AvTimerOutlined, DateRangeOutlined, EqualizerOutlined } from '@mui/icons-material';
// import Header from '../components/Header';
import useCourseDetails from '../../shared/logic/useCourseDetails';
import ReactPlayer from 'react-player' // react video player
import { useCompanyData } from '../../shared/contexts/DataContext';
import CustomButton from '../../Template3/components/CustomButton';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import { db } from 'src/config/firebase';
import Carousel from 'react-elastic-carousel';
import imgProfile from 'src/assets/images/templates/profile.jpg';
import moment from 'moment';
import CustomMetaData from 'src/hooks/CustomMetaData';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { createMarkup } from '../../shared/logic/Utils';
import { bannerImage as BannerImage } from '../../shared/logic/imagesFns';
import useRTL from 'src/hooks/useRTL';
import { MinutesTo12HourFormat } from 'src/hooks/MinutesTo12HourFormat';
import determineFileType from 'src/screens/Partners/Courses/hook/checkfileType'
import { calculateRating } from 'src/config/RatingCalculation';
import "react-image-gallery/styles/css/image-gallery.css";
import { PhotoPreview } from 'src/components/white-label-component/company-comp';
import MemberLogo from 'src/assets/images/placeholder.png';
import CourseCard from './OtherCourseCard';
import DiscountIcon from 'src/assets/images/templates/discount.png';
import RiyalIcon from 'src/assets/images/welcome/riyalBlue.svg';
import RiyalGrayIcon from 'src/assets/images/welcome/riyalGray.svg';
import TemplateICourseCard from '../../Template1/components/CourseCard';
import TemplateIICourseCard from '../../Template2/components/CourseCard';
import TemplateIIICourseCard from '../../Template3/components/CourseCard';
import TemplateIVCourseCard from '../../Template4/components/CourseCard';

const theme = createTheme();
// Custom style tab and tabs
const CustomTabs = withStyles({
  root: {
      border:'none',
      backgroundColor: 'transparent',
      boxShadow:'none',
      padding:'0px 0px 5px 0px',
      color:'#7A889B'
  },
  indicator: {
    backgroundColor: '#000000',
  },
})(Tabs);
const CustomTab = withStyles((theme) => ({
  root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontSize:"14px",
      color:'#7A889B',
      '&:hover': {
          color: '#000',
          opacity: 1,
      },
      '&$selected': {
          color: '#000',
      },
      '&:focus': {
          color: '#000',
      },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const StyledRating = withStyles({
    iconFilled: {
        color: '#ECC605',
    }
})(Rating);

const useCourseStyles = makeStyles(theme => ({
    boxRoot:props=>({
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        margin:'auto',
        textAlign:"center",
        width: "100%",
        borderRadius: '0px',
        height: '520px',
        position:'relative',
        '&::after':{
            content: "''",
            position: "absolute",
            width: "100%",
            height: '520px',
            backgroundImage: `linear-gradient(180deg, rgba(15,70,122,1) 0%, rgba(255,255,255,0) 100%), url(${props.image})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: 'center center',
        },
    }),
}));

const useRatingStyles = makeStyles(() => ({
    root:{
        fontSize:'1.5rem !important'
    },

    iconFilled:{
        color: '#fac400 !important',
    },

    iconHover:{
        color: '#fac400',
    },

    iconEmpty:{
        color: '#fac400 !important',
    },

    icon:{
        display:'unset !important'
    }
}));


const useStyles = makeStyles(() => ({
    rowDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },

    indicator: {
        backgroundColor: "#000000"
    },

    carousel: {
        position: 'relative',
        '& .rec.rec-arrow': {
          position: 'absolute',
          backgroundColor: '#EDEBEB',
          zIndex: '10',
          top: '0%',
          height:'100%',
          borderRadius:'3px',
          border: 'none',
          width:'27px',
          minWidth:'27px',
        },
        '& .rec.rec-dot': {
          display:'none'
        },
        '& .rec.rec-arrow:last-child': {
          right: 0,
        },
        '& .rec.rec-arrow:hover': {
          backgroundColor: '#EEF0F5',
          color:'#000'
        },
        '& .rec.rec-arrow:disabled': {
          visibility: 'hidden',
        },
        '& .rec.rec-item-wrapper':{
            width:'fit-content !important'
        }
    },

    descSpan:{
        '& li':{
        listStyle:'inherit'
        }
    },

    courseInfoDiv:{
        width:'346px',
        minHeight:'400px',
        borderRadius:'10px',
        boxShadow:'0px 0px 25px #00000029',
        backgroundColor:'#fff',
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        position:'relative',
        justifyContent:'flex-end',
        [theme.breakpoints.down('lg')]:{
            width:'300px'
        },
        [theme.breakpoints.down('md')]:{
            marginLeft:'0px !important',
            width:'95%',
            marginTop:'15px',
            // position:'unset'
        }
    },

    courseInfoMb:{
        display:'none',
        [theme.breakpoints.down('md')]:{
            display:'flex'
        }
    },

    courseInfoRight:{
        right:'410px',
    },

    courseInfoLeft:{
        left:'410px',
    },

    infoDiv:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        width:'657px',
        maxWidth:'657px',
        [theme.breakpoints.down('md')]:{
            width:'100%',
            maxWidth:'100%',
        },
    },

    courseInfoUp:{
        padding:'15px 21px 0px 21px',
        width:'calc(100% - 42px)',
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        position:'absolute',
        top:0,
    },

    courseName:{
        color:'#000000',
        fontSize:'20px',
        fontWeight:600,
        textTransform:'capitalize'
    },

    courseShortDesc:{
        color:'#000',
        fontSize:'12px',
        fontWeight: 300,
        paddingTop:'5px',
        maxHeight: '40px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'break-spaces',
        marginBottom:'20px'
    },

    coursePointTitle:{
        color:'#0F467A',
        fontSize:'12px',
        fontWeight:300,
        textTransform:'capitalize'
    },

    marRight:{
        marginRight:'10px'
    },

    marLeft:{
        marginLeft:'10px'
    },

    marRight24:{
        marginRight:'24px'
    },

    marLeft24:{
        marginLeft:'24px'
    },

    priceSpan:{
        color:'#0F467A',
        fontSize:'30px',
        fontWeight:'bold',
        textTransform:'uppercase'
    },

    discountIcon:{
        width:'23px',
        height:'23px',
        padding:'0px 5px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    buyBtn:{
        backgroundColor:'#FFCC00',
        color:'#0F467A',
        border: '1px solid #36ABEF',
        textTransform:'capitalize',
        fontSize:'18px',
        fontWeight:600,
        boxShadow:'0px 3px 6px #00000029',
        borderRadius:'22px',
        textAlign:'center',
        height:'38px',
        width:'121px',
        cursor:'pointer'
    },

    colDiv:{
        display:'flex',
        flexDirection:'column'
    },

    introDiv:{
        height: '383px',
        width: '657px',
        borderRadius: '10px',
        boxShadow: '0px 0px 25px #00000029',
        display:'flex',
        position:'relative',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        alignSelf:'center',
        [theme.breakpoints.down('md')]:{
            width:'100%',
            height:'300px',
        },

        '& img':{
            width:'100%',
            height:'100%',
            borderRadius:'10px',
            objectFit:'cover'
        }
    },

    reactPlayer:{
        width:'100% !important',
        height:'100% !important',
        borderRadius:'10px',
        "& video":{
            width:'100% !important',
            height:'100% !important',
            objectFit:'cover',
            borderRadius:'10px',
        },
        "& iframe":{
            borderRadius:'10px',
        },

        '&.react-player__preview':{
            borderRadius:'10px'
        }
    },

    iconDiv:{
        width:'623px',
        height:'350px',
        cursor:'pointer',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        position:'absolute',
        top:0,
        transition:'0.5s',
        zIndex:5,
        "&:hover":{
            opacity:0.5
        },
        "& svg":{
            fontSize:'3em',
            width:'74px',
            height:'74px',
            color:'#fff'
        },
        [theme.breakpoints.between('xs','md')]:{
            width:'100%',
            height:'100%',
        }
    },

    viewTab:{
        width:'70rem',
        margin:'auto',

        [theme.breakpoints.down('lg')]:{
            width:'48rem'
        },
        [theme.breakpoints.down('md')]:{
            width:'95%',
            marginTop:'290px'
        },
    },

    viewTab2:{
        [theme.breakpoints.down('md')]:{
            width:'95%',
            marginTop:'80px'
        },
    },

    memberImg:{
        width:'45px',
        height:'45px',
        borderRadius:'50%',

        '& img':{
            width:'100%',
            height:'100%',
            borderRadius:'50%'
        }
    },

    memberName:{
        fontSize:'14px',
        color:'#000',
        textTransform:'capitalize'
    },

    textShadowDiv:{
        boxShadow:'0px 0px 25px #00000017',
        backgroundColor:'#fff',
        borderRadius:'10px',
        padding:'19px 30px',
        width:'calc(100% - 60px)',
        margin:'23px 0px 39px 0px'
    },

    contentMainContainer:{
        padding:'19px 16px',
        width:'calc(100% - 32px)',
        zIndex:50
    },

    contentName:{
        fontSize:'14px',
        color:'#000',
        width:'calc(100% - 201px)'
    },

    prevBtn:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        cursor:'pointer',
        
        '& span':{
            fontSize:'14px',
            padding:'0px 5px',
            color:'#36ABEF',
            textTransform:'capitalize'
        },

        '& svg':{
            color:'#36ABEF'
        }
    },

    newContainer:{
        width:'40px',
        height:'17px',
        borderRadius:'9px',
        backgroundColor:'#36ABEF',
        fontSize:'12px',
        textAlign:'center',
        textTransform:'capitalize',
        color:'#fff',
        lineHeight:1.4
    },

    marLeft16:{
        marginLeft:'16px'
    },

    marRight16:{
        marginRight:'16px'
    },

    contentMainDiv:{
        width:'calc(100% - 20px)',
        padding:'14px 10px',
        borderBottom:'1px solid #afb4b4'
    },

    memberContainer:{
        margin:'0px 0px 23px 0px'
    },

    headerContent:{
        zIndex:35,
        alignItems:'flex-end',
        marginTop:'80px',
        position:'relative',
        pointerEvents: 'none', // Disable clicks on container
        '& *': {
            pointerEvents: 'auto' // Allow clicks on child elements
        },
    

        [theme.breakpoints.down('md')]:{
            width:'100%',
            flexDirection:'column',
            alignItems:'center',
            marginTop:'300px'
        }
    },

    infoContainer:{
        // width: '70rem',
        position: 'fixed',
        zIndex: 36,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginTop:'80px',
        [theme.breakpoints.down('md')]:{
            display:'none'
        }
    }
}));

const CourseDetail = () => {
    const [activeTab, setActiveTab] = React.useState(0);
    const [previewDialog, setPreviewDialog] = React.useState(false);
    const [previewSrc, setPreviewSrc] = React.useState('');
  
    const { course, reviews, contents, handleBooking, t } = useCourseDetails();
    const [, isRTL,  fontFamily] = useRTL();
    const { data } = useCompanyData();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const { id, seoTitle, seoMetaDescription, subscription, groupId } = course || {};
    const { buttonColor, buttonFontColor, companyData, courses } = data || {};
    const classes = useStyles();

    const [_previewDialog, _setPreviewDialog] = React.useState(false);
    const [activeImg, setActiveImg] = React.useState('');
    const [_fileType, setFileType] = React.useState('image');

    const { displayDescription, displayTrainer, displayUserReview } = course || {};
    const RTLmarginCl = isRTL ? classes.marRight : classes.marLeft;

    const filterCourse = courses?.length && id && courses.filter(v=> v.id !== id)?.length ? 
    courses.filter(v=> v.id !== id) : [];

    useEffect(() => {
        // ❌ Disable Right Click
        const disableRightClick = (event) => event.preventDefault();
        document.addEventListener("contextmenu", disableRightClick);
    
        // ❌ Disable Keyboard Shortcuts (Windows + Mac)
        const disableKeyboardShortcuts = (event) => {
            if (
            event.key === "F12" || 
            (event.ctrlKey && event.shiftKey && (event.key === "I" || event.key === "J" || event.key === "∆" || event.key === "C" || event.key === "U" || event.key === "S")) || 
            (event.metaKey && event.altKey && (event.key === "I" || event.key === "J" || event.key === "∆" || event.key === "C" || event.key === "U" || event.key === "S")) || 
            (event.ctrlKey && event.key === "U") || 
            (event.metaKey && event.key === "U") || 
            (event.key === "Escape")  // Prevents DevTools on some browsers
            ) {
            event.preventDefault();
            return false;
            }
        };
        document.addEventListener("keydown", disableKeyboardShortcuts);
    
        // ❌ Detect DevTools (Via Console.log Debugging)
        const detectDevTools = () => {
            const element = new Image();
            element.__defineGetter__("id", function () {
            alert("Developer tools detected! Please close them.");
            window.location.reload();
            });
            console.log("%c", element);
        };
        detectDevTools();
    
        // ❌ Detect DevTools (Resize Trick)
        // const checkDevToolsOpen = () => {
        //     if (window.outerWidth - window.innerWidth > 200 || window.outerHeight - window.innerHeight > 200) {
        //     // alert("Developer tools detected! Please close them.");
        //     // window.location.reload();
        //     }
        // };
        // const devToolsChecker = setInterval(checkDevToolsOpen, 1000);
    
        // Cleanup on Unmount
        return () => {
            document.removeEventListener("contextmenu", disableRightClick);
            document.removeEventListener("keydown", disableKeyboardShortcuts);
            // clearInterval(devToolsChecker);
        };
    }, []);

     //Handler to update the current index on click of left button
     const _previewEvent = (img,fileType) => {
        _setPreviewDialog(true);
        setActiveImg(img);
        setFileType(fileType);
    };

    const _closeDialog = () => {
        _setPreviewDialog(false);
        setActiveImg('');
        setFileType('image');
    };

    const handleChange = (event, newValue) => { // tab click event
        setActiveTab(newValue);
    };

    const showAllReviews = () => {
        window.scrollTo(0,0);
        setActiveTab(2);
    }

    useEffect(()=> {
        window.scrollTo(0, 0);
    },[id])

    const closeDialog = () => {
        setPreviewDialog(false);
        setPreviewSrc('');
    }
    const openDialog = (previewSrc) => {
        setPreviewDialog(true);
        setPreviewSrc(previewSrc);
    };

    return (
        <>
        <div>
        <CustomMetaData
            {...{
            title: seoTitle || course?.enName,
            image: companyData && companyData.avatar,
            description: seoMetaDescription || course?.shortDescription
            }}
        />
        <Header
            image={BannerImage(data)}
            data={data}
            height="520px"
            transparencyColor={'#15476db2'}
            fontFamily={fontFamily}
        >
            <div className={`${classes.rowDiv} ${classes.headerContent}`}>
                <CourseCover 
                    {...{
                        fontFamily,
                        openDialog,
                        _previewEvent,
                        cover:course?.cover || '',
                    }}
                />

                <CourseInfo 
                    {...{
                        classes, 
                        course, 
                        displayUserReview,
                        reviews,
                        RTLmarginCl, 
                        groupId,
                        handleBooking,
                        subscription,
                        fontFamily,
                        t,
                        isRTL,
                        addMbClass:true
                    }}
                />
                <div className={classes.infoContainer} style={isRTL ? {left:'8rem'} : {right:'8rem'}}>
                    <CourseInfo 
                        {...{
                            classes, 
                            course, 
                            displayUserReview,
                            reviews,
                            RTLmarginCl, 
                            groupId,
                            handleBooking,
                            subscription,
                            fontFamily,
                            t,
                            isRTL,
                            addMbClass: false
                        }}
                    />
                </div>
            </div>
        </Header>
        <div className={`${classes.colDiv} ${classes.viewTab}`}>
            <TabButtons activeTab={activeTab} fontFamily={'inherit'} buttonColor={buttonColor} buttonFontColor={buttonFontColor} handleChange={handleChange} t={t} isRTL={isRTL} />
            
            {activeTab === 0 ?
            <div className={classes.infoDiv}>
                <span className={classes.courseName} style={{fontFamily:'inherit',padding:'20px 0px 23px 0px'}}>{isRTL ? course?.arName ? course?.arName : course?.enName : course?.enName || '---'}</span>
            
                {displayTrainer && course.courseDeliver ?
                <TeamMember 
                    {...{
                        fontFamily,
                        t,
                        classes,
                        courseDeliver: course?.courseDeliver || ''
                    }}
                />
                : null}

                {displayDescription ?
                <>
                    <span className={classes.courseName} style={{fontFamily:'inherit',fontWeight:500}}>{t && t('coursePage.overview')}</span>
                    <div className={classes.textShadowDiv}>
                        <Typography variant="body1" className={classes.descSpan} dangerouslySetInnerHTML={createMarkup(course?.description)}></Typography>
                    </div>
                </>
                : null}

                <span className={classes.courseName} style={{fontFamily:'inherit',fontWeight:500}}>{t && t('courses.courseContent')}</span>

                <div className={`${classes.textShadowDiv} ${classes.contentMainContainer}`}>
                    {course?.Sections?.length ? React.Children.toArray(course.Sections.map(val=> {
                        return (
                            <CustomAccordion {...{
                                title: isRTL ? val['arName'] ? val['arName'] : val['enName'] : val['enName'],
                                contents,
                                contentList:val?.['contentList'],
                                isRTL,
                                t,
                                childComponent: (
                                <div className={classes.colDiv} style={{width:'100%'}}>
                                    {val?.['contentList']?.length ? React.Children.toArray(val?.['contentList'].map(v=> {
                                        return <Content contentId={v} contents={contents} openDialog={openDialog} classes={classes} t={t} isRTL={isRTL} fontFamily={fontFamily} />
                                    })) 
                                    : null
                                    }
                                </div>
                                )
                            }}/>
                        )
                    }))
                    : null
                    }
                </div>
                
                {/* other courses */}
                {filterCourse?.length ?
                <>
                    <span className={classes.courseName} style={{fontFamily:'inherit',fontWeight:500}}>{t && t('coursePage.otherCourses')}</span>
                    <OtherCourses 
                        {...{
                            fontFamily,
                            t,
                            classes,
                            courses:filterCourse,
                            courseId: id,
                            data
                        }}
                    />
                </>
                : null}

                <span className={classes.courseName} style={{fontFamily:'inherit',fontWeight:500}}>{t && t('coursePage.prerequites')}</span>

                <div className={classes.textShadowDiv} style={{marginTop:'15px'}}>
                    <Typography variant="body1" className={classes.descSpan} dangerouslySetInnerHTML={createMarkup(course?.prerequisties)}></Typography>
                </div>
            </div>
            : null}

            {activeTab === 1 ?
                <div className={classes.infoDiv}>
                    <span className={classes.courseName} style={{fontFamily:'inherit',fontWeight:500}}>{t && t('courses.courseContent')}</span>

                    <div className={`${classes.textShadowDiv} ${classes.contentMainContainer}`}>
                        {course?.Sections?.length ? React.Children.toArray(course.Sections.map(val=> {
                            return (
                                <CustomAccordion {...{
                                    title: isRTL ? val['arName'] ? val['arName'] : val['enName'] : val['enName'],
                                    contents,
                                    contentList:val?.['contentList'],
                                    isRTL,
                                    t,
                                    childComponent: (
                                    <div className={classes.colDiv} style={{width:'100%'}}>
                                        {val?.['contentList']?.length ? React.Children.toArray(val?.['contentList'].map(v=> {
                                            return <Content contentId={v} contents={contents} openDialog={openDialog} classes={classes} t={t} isRTL={isRTL} fontFamily={fontFamily} />
                                        })) 
                                        : null
                                        }
                                    </div>
                                    )
                                }}/>
                            )
                        }))
                        : null
                        }
                    </div>
                </div>
            : null}

            {activeTab === 2 ?
                <div className={classes.infoDiv}>
                    {reviews.length > 0 ? 
                        <>
                        <Reviews reviews={reviews} t={t} data={data} matches={matches} />
                        <Box display="flex" flexDirection="column" alignItems="flex-end">
                        <CustomButton
                            style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
                            variant="contained"
                            onClick={showAllReviews}
                        >
                            {t && t('companyPage.exploreServices')}
                        </CustomButton>
                        </Box>
                        </>
                    :
                    <Typography style={{fontFamily:'inherit'}}>{t && t('companyPage.sorryNoReviews')}</Typography>
                    }
                </div>
            : null}
        </div>

        {previewDialog && <PhotoPreview dataArray={[{path:previewSrc,type:'video'}]} closeEvent={closeDialog} />}
        </div>
            {_previewDialog && activeImg ? <PhotoPreview dataArray={[{path:activeImg,type:_fileType}]} closeEvent={_closeDialog} /> : null}
        </>
    );
};

const Header = ({ image,transparencyColor ,data, page,matches,children, ...props }) => {
    const classes = useCourseStyles({transparencyColor,image});
    return (
      <Box
        className={classes.boxRoot}
        {...props}
      >
        {children}
      </Box>
    );
};

const CourseInfo = (props) => {
    const { classes, course, displayUserReview, reviews, RTLmarginCl, groupId, handleBooking, subscription, fontFamily, t, isRTL, addMbClass } = props;
    const currentTime = moment().unix();
    const isOffer = course?.offer && course?.offerPrice && course.offerValidity > currentTime;
    const isConvertCurrency = course?.convertCurrency && course?.displayPrice && course?.displayCurrency;

    return(
        <div className={`${classes.courseInfoDiv} ${addMbClass ? classes.courseInfoMb : ''}`}>
            <div className={classes.courseInfoUp}>
                <span className={classes.courseName} style={{fontFamily:'inherit'}}>{isRTL ? course?.arName ? course?.arName : course?.enName : course?.enName || '---'}</span>
                <span className={classes.courseShortDesc} style={{fontFamily:'inherit'}}>{course?.shortDescription || ''}</span>

                {course?.durations ?
                <CoursePoints {...{
                    fontFamily,
                    icon: <AvTimerOutlined style={{color:'#000'}}/>,
                    title: t && t('coursePage.duration',{duration: MinutesTo12HourFormat(Number(course.durations))})
                }}/>
                : null}

                <CoursePoints {...{
                    fontFamily,
                    icon: <DateRangeOutlined style={{color:'#000'}}/>,
                    title: t && t('coursePage.lastUpdate',{time: moment(course?.updatedAt ? new Date(course.updatedAt*1000): new Date()).format('Do MMM YYYY')})
                }}/>

                {course?.level ?
                <CoursePoints {...{
                    fontFamily,
                    icon: <EqualizerOutlined style={{color:'#000'}}/>,
                    title: t && t('coursePage.level',{level: course.level})
                }}/>
                : null}
            </div>


            <div style={{width:'100%',display:'flex',flexDirection:'column',alignItems:'flex-start',padding:'10px 0px'}}>
                {displayUserReview ?
                <div className={classes.colDiv} style={{padding:'0px 21px 15px 21px',alignItems:'flex-start'}}>
                <span style={{fontFamily:'inherit',paddingTop:'0px',marginBottom:'0px',fontWeight:400}} className={classes.courseShortDesc}>{t && t('coursePage.averageRating')}</span>
                <div className={classes.rowDiv}>
                    <StyledRating name="half-rating-read" emptyIcon={<StarOutlineRounded fontSize="inherit" />} classes={{root: isRTL === 'ar' ? classes.rootStarRight : classes.rootStarLeft}} value={calculateRating(reviews)} precision={0.1} readOnly />
                    <span style={{fontFamily:'inherit',fontSize:'14px'}}><span className={RTLmarginCl}>{calculateRating(reviews)}</span> <span className={RTLmarginCl} style={{color:'#7A889B'}}>({t && t('coursePage.totalReview',{total:reviews?.length})})</span></span>
                </div>
                </div>
                : null}

                <Divider style={{width:'100%'}}/>

                <div className={classes.courseInfoUp} style={{flexDirection:'row',alignItems:'center',justifyContent:'space-between',padding:'5px 21px 0px 21px',position:'unset'}}>
                    {subscription === 'ticket-free' ?
                    <span className={classes.priceSpan} 
                    >Free</span>
                    :
                    <div className={classes.colDiv} style={{alignItems:'flex-start',visibility: subscription === 'ticket-free' ? 'hidden' : 'visible'}}>
                        <span className={classes.courseShortDesc} style={{fontFamily:'inherit',marginBottom:'0px',maxHeight:'unset',paddingTop:'0px'}}>{t && t('group-comp.price')}</span>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'-10px'}}>
                            {isConvertCurrency ?
                                (course?.displayCurrency === 'SAR' ?
                                     <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                        <span className={classes.priceSpan} style={{fontFamily:'inherit'}}>{course.displayPrice} </span>
                                        <img src={RiyalIcon} alt='riyal' width="25" height="25" />
                                    </div>
                                :
                                <span className={classes.priceSpan} style={{fontFamily:'inherit'}}>
                                    {`${course?.displayPrice} ${course?.displayCurrency}`}
                                </span>)
                            :
                            course?.currency === 'SAR' ?
                                     <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                        <span className={classes.priceSpan} style={{fontFamily:'inherit'}}>{isOffer ? course?.offerPrice : course?.price} </span>
                                        <img src={RiyalIcon} alt='riyal' width="25" height="25" />
                                    </div>
                                :
                                <span className={classes.priceSpan} style={{fontFamily:'inherit'}}>
                                    {`${isOffer ? course?.offerPrice : course?.price} ${course?.currency}`}
                                </span>
                            }

                            {/* <span className={classes.priceSpan} style={{fontFamily:'inherit'}}>
                                {isConvertCurrency ?
                                `${course.displayPrice} ${course.displayCurrency}` :
                                `${isOffer ? course?.offerPrice : course?.price} ${course?.currency}`}
                            </span> */}
                            {isOffer ?
                            <div className={classes.discountIcon}>
                                <img src={DiscountIcon} alt='discount' />
                            </div>
                            : null}
                        </div>
                        {isOffer ?
                        course.currency === 'SAR' ?
                        <div style={{display:'flex',flexDirection: 'row',alignItems:'center'}}>
                            <span style={{
                                fontFamily:'inherit',
                                textDecoration: 'line-through',
                                fontSize:'18px',
                                color:'#7A889B',
                                }}
                            >{course.price} </span>
                            <img src={RiyalGrayIcon} alt='riyal' width="18" height="18" />
                        </div>
                        :
                        <span style={{
                            fontFamily:'inherit',
                            textDecoration: 'line-through',
                            fontSize:'18px',
                            color:'#7A889B',
                            marginTop:'-10px'
                            }}
                        >{course.price} {course.currency}</span>
                        : null}
                        {isConvertCurrency ?
                            course?.currency === 'SAR' ?
                            <div style={{display:'flex',flexDirection:isRTL ? 'row-reverse' : 'row',alignItems:'center'}}>
                                <span style={{
                                    fontFamily:'inherit',
                                    fontSize:'13px',
                                    color:'#7A889B',
                                    }}
                                >{`Pay ${course?.price} `}</span>
                                <img src={RiyalGrayIcon} alt='riyal' width="18" height="18" />
                            </div>
                            :
                            <span style={{
                                fontFamily:'inherit',
                                fontSize:'13px',
                                color:'#7A889B',
                                marginTop:'-10px'
                                }}
                            >{`Pay ${course?.price} ${course.currency}`}</span>
                        : null}
                    </div>
                    }

                    <button style={{fontFamily:'inherit'}} className={classes.buyBtn} onClick={()=> handleBooking(groupId)}>{subscription === 'ticket-free' ? t && t('coursePage.joinNow') : t && t('coursePage.buyNow')}</button>
                </div>
            </div>
        </div>
    )
};

const TeamMember = ({ fontFamily,t,data, classes, courseDeliver, ...props }) => {
    const [memberInfo,setMemberInfo] = useState({});
    const [loading,setLoading] = useState(true);

    useEffect(()=> {
        async function getMemberInfo() {
            setLoading(true);
            try{
                const teamMember = await (await db.ref(`PartnerTeams/${courseDeliver}`).once('value')).val();

                if(teamMember) {
                    setMemberInfo(teamMember);
                    setLoading(false);
                }
                else{
                    try{
                        const partner = await (await db.ref(`Partners/${courseDeliver}`).once('value')).val();
                        if(partner) {
                            setMemberInfo(partner);
                            setLoading(false);    
                        }
                        else{
                            setMemberInfo({});
                            setLoading(false);                        
                        }
                    }
                    catch(e) {
                        setMemberInfo({});
                        setLoading(false);
                    }
                }
                
            }
            catch(e) {
                setMemberInfo({});
                setLoading(false);
            };
        }

        if(courseDeliver) getMemberInfo();

    },[courseDeliver])


    return (<>
        {!loading ?
        <div className={`${classes.rowDiv} ${classes.memberContainer}`}>
            <div className={classes.memberImg}>
                <img src={memberInfo?.avatar || MemberLogo} alt={memberInfo?.firstName || 'member'} />
            </div>
            <div className={classes.colDiv} style={{padding:'0px 10px'}}>
                <span className={classes.courseShortDesc} style={{fontFamily:'inherit',marginBottom:'3px',maxHeight:'unset',textTransform:'capitalize'}}>{t && t('coursePage.presentedBy')}</span>
                <span style={{fontFamily:'inherit'}} className={classes.memberName}>{memberInfo?.firstName ? `${memberInfo?.firstName} ${memberInfo?.firstName || ''}` : ''}</span>
            </div>
        </div>
        :
        <div className={classes.rowDiv}>
            <Skeleton variant="circular" width={45} height={45} />
            <div className={classes.colDiv} style={{padding:'0px 10px'}}>
                <Skeleton variant="text" width={100} />
                <Skeleton variant="text" width={150} />
            </div>
        </div>
        }
    </>);
};

const Content = ({fontFamily,t,contents,contentId, classes,  openDialog, isRTL}) => {
    const [duration, setDuration] = useState(null);
    const [formattedDuration, setFormattedDuration] = useState(null);

    const contentData = contents?.length ? contents.filter(v=> v.id === contentId)?.[0] : {};
    const { name, fileType, file, visible, freeContent, markNewRelease } = contentData || {};
    const RTLMarCl = isRTL ? classes.marRight16 : classes.marLeft16;
    const RTLMarClOppsite = isRTL ? classes.marLeft : classes.marRight;

    useEffect(() => {
        // Convert duration to mm:ss format
        if (duration !== null) {
          const minutes = Math.floor(duration / 60);
          const seconds = Math.floor(duration % 60);
          setFormattedDuration(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
        }
    }, [duration]);

    useEffect(() => {
        if (fileType === "video") {
          getVideoDuration(file).then((duration) => {
            setDuration(duration);
          });
        }
    }, [file, fileType]);

    const PreviewBtn = () => {
        return(
            <div className={`${classes.prevBtn}`} onClick={()=> fileType === 'video' ? openDialog(file) : window.open(file,'_blank')}>
                <PlayCircleFilledOutlined />
                <span style={{fontFamily:'inherit'}}>{t && t('coursePage.preview')}</span>
            </div>
        )
    }

    if(visible)
    return(
        <div className={classes.contentMainDiv}>
            <div className={classes.rowDiv} style={{justifyContent:'space-between',width:'100%'}}>
                <span style={{fontFamily:'inherit',...(isRTL ? {marginRight:'40px'} : {marginLeft:'40px'})}} className={classes.contentName}>{name || ''}</span>

                <div className={classes.rowDiv}>
                    {markNewRelease ? <div className={`${classes.newContainer} ${RTLMarClOppsite}`} style={{fontFamily:'inherit'}}>{t && t('reservation.new')}</div> : null}
                    {freeContent ? <PreviewBtn /> : null}
                    {fileType === 'video' ? <span className={RTLMarCl} style={{fontFamily:'inherit',color:'#737B8B',minWidth:'30px'}}>{formattedDuration}</span> : null}
                </div>
            </div>
        </div>
    );

    return null;
};

const OverviewSectionTitle = ({ children, ...props }) => {
  return (
    <Box pb={3} {...props}>
      <Typography style={{ color: '#16466d', fontWeight: 600 }} variant="h6">
        {children}
      </Typography>
    </Box>
  );
};

const Reviews = ({ reviews, t, data, matches }) => {
  const { setPage, count, currentItems } = useMyPagination(reviews, 3);

  return (
    <Box width="100%" pb={3}>
      <OverviewSectionTitle>
        {t && t('companyPage.reviews')}
      </OverviewSectionTitle>
      <div>
        {currentItems?.map((item, i) => (
          <ReviewItem key={i} review={item} data={data} matches={matches} />
        ))}
      </div>
      <MyPagination count={count} onChange={setPage} />
    </Box>
  );
};

const ReviewItem = ({ review, data, matches }) => {
  const classes = useRatingStyles();
  
  return (
    <Box
      color="#15476D"
      display="flex"
      flexDirection="column"
      py={3}
      px={3}
      mb={3}
      bgcolor="#FAFAFA"
      border="1px solid #EFEFEF"
    >
      <Box mb={3} display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Box width="50px" height="50px" borderRadius="50%" mr={2} style={{border:'1px solid rgb(239, 239, 239)'}}>
          <ImgLazyLoad>
            <img
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              src={review.parentAvatar || imgProfile}
              alt={review.parentName || 'profile'}
            />
          </ImgLazyLoad>
          </Box>
          <div>
            <Typography variant="subtitle1" style={{ fontWeight: 600, textTransform:'capitalize' }}>
              {review.parentName || '---'}
            </Typography>
            <Typography variant="subtitle2" color="textPrimary">
              {review.reviewDate ? moment(new Date(review.reviewDate*1000)).format('D MMM YYYY') : '---'}
            </Typography>
          </div>
        </Box>
        <Rating
          classes={{
            iconHover:classes.iconHover,
            iconFilled:classes.iconFilled,
            iconEmpty:classes.iconEmpty,
            icon:classes.icon
          }}
          name="review-rating"
          value={Number(review.rating)}
          precision={0.1}
          readOnly
          emptyIcon={<StarBorder fontSize="inherit" />}
        />
      </Box>
      <Box pl={8}>
        <Typography color="textPrimary">{review.comment}</Typography>
      </Box>
      { review.reply ? <ReviewReply review={review} data={data} matches={matches} /> : null }
    </Box>
  );
};

const ReviewReply = ({review, data,matches}) => {
  const { avatar, name } = data.companyData || {};
  return(
    <Box
      color="#15476D"
      py={3}
      px={3}
      mt={2}
      width={matches ? "calc(100% - 112px)" : "calc(100% - 48px)"}
      alignSelf="flex-end"
      bgcolor="#fff"
      border="1px solid #EFEFEF"
    >
      <Box mb={3} display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Box width="50px" height="50px" borderRadius="50%" mr={2} style={{border:'1px solid rgb(239, 239, 239)'}}>
            <ImgLazyLoad>
            <img
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              src={avatar || imgProfile}
              alt={name || 'profile'}
            />
            </ImgLazyLoad>
          </Box>
          <div>
            <Typography variant="subtitle1" style={{ fontWeight: 600, textTransform:'capitalize' }}>
              {name || '---'}
            </Typography>
            <Typography variant="subtitle2" color="textPrimary">
              {review.replyDate ? moment(new Date(review.replyDate*1000)).format('D MMM YYYY') : '---'}
            </Typography>
          </div>
        </Box>
      </Box>
      <Box>
        <Typography color="textPrimary">{review.reply}</Typography>
      </Box>
    </Box>
  )
};

const TabButtons = ({activeTab,handleChange,isRTL,t,fontFamily}) => {
  const classes = useStyles();
  return(
    <CustomTabs
        value={activeTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        classes={{indicator:classes.indicator}}
        style={{backgroundColor: 'transparent'}}
    >
        <CustomTab style={{fontFamily:'inherit'}} className={isRTL === 'ar' ? classes.marLeft : classes.marRight} label={t && t('companyPage.overview')} {...a11yProps(0)} />
        <CustomTab style={{fontFamily:'inherit'}} className={isRTL === 'ar' ? classes.marLeft : classes.marRight} label={t && t('coursePage.content')} {...a11yProps(1)} />
        <CustomTab style={{fontFamily:'inherit'}} className={isRTL === 'ar' ? classes.marLeft : classes.marRight} label={t && t('companyPage.reviews')} {...a11yProps(2)} />
    </CustomTabs>
  )
};

const CoursePoints = ({icon,title,fontFamily})=> {
    const classes = useStyles();

    return(
        <div className={classes.rowDiv} style={{padding:'5px 0px'}}>
            {icon}
            <span className={classes.coursePointTitle} style={{padding:'0px 5px',fontFamily:'inherit'}}>{title}</span>
        </div>
    )
};

const CourseCover = ({openDialog,cover,_previewEvent}) => {
    const classes = useStyles();

    const fileType = determineFileType(cover);

    return(
        <div className={`${classes.viewTab} ${classes.viewTab2}`}>
            <div className={classes.introDiv}>
                {fileType === 'video' ?
                <>
                    <ReactPlayer url={cover}
                    className={classes.reactPlayer} />
                    <div className={classes.iconDiv} onClick={()=> _previewEvent(cover,'video')}>
                        <PlayCircleOutlineOutlined />
                    </div>
                </>
                :
                fileType === 'image' ? 
                <img src={cover} alt='cover' onClick={()=> _previewEvent(cover,'image')} style={{cursor:'pointer'}}/>
                : 
                null
                }
            </div>
        </div>
    )
};

const accordionUseStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: '0px',
        margin: '10px auto',
        backgroundColor:'#F5F6F8',
        borderRadius:'5px'
    },

    header:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        width:'100%',

        '& span':{
            fontSize: '14px',
            fontWeight: 500,
            color:'#000000',
            textTransform:'capitalize',
            maxWidth: '250px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',

            [theme.breakpoints.down('sm')]: {
                maxWidth:'150px'
            }
        },

        "& button":{
            cursor:'pointer'
        }
    },

    accordionRoot:{
        boxShadow:'none',
        border:'1px solid #EBECEC',
    },

    marLeft:{
        marginLeft:'10px'
    },

    marRight:{
        marginRight:'10px'
    },

    accSumRoot:{
        backgroundColor:'#EEF0F5',
        minHeight:'30px',
        padding:'0px',
        borderRadius:'5px'
    },

    accContent:{
        margin:'0px'
    },

    expandedCls:{
        margin:'0px !important'
    },

    accDetail:{
        padding:'0px'
    }
}));

function CustomAccordion(props) {
    const classes = accordionUseStyles();
    const { childComponent ,isRTL,contents,contentList, t, title, rootCustomClass, accordionRootCustomCls,expanded, expandId, onChange, editSectionEvent, deleteEvent, visibleEvent,visible } = props;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL ? ar : en;
    let contentExist = contentList?.length ? contents.filter(content => contentList.includes(content.id) && content.visible) : [];
    if(contentExist?.length) {
    return (
        <div className={`${classes.root} ${rootCustomClass}`}>
            <Accordion
                classes={{root:`${classes.accordionRoot} ${accordionRootCustomCls}`}}
            >
            <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            classes={{root:classes.accSumRoot,content:classes.accContent,expanded:classes.expandedCls}}
            aria-controls="panel1a-content"
            id="panel1a-header"
            >
                <div className={classes.header}>
                    {/* {customPage ? */}
                    <span style={{fontFamily:'inherit'}} className={isRTL ? classes.marRight : classes.marLeft}>{title}</span>
                    <div className={classes.rowDiv}>
                        <span style={{fontFamily:'inherit',color:'#737B8B',fontSize:'12px'}}>{t && t('coursePage.contentLength',{total:contentExist?.length})}</span>
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails classes={{root:classes.accDetail}}>
                {childComponent}
            </AccordionDetails>
        </Accordion>
        </div>
    )};

    return null;
}

function OtherCourses({ courses, classes, data }) {
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 900, itemsToShow: 2 },
        { width: 1000, itemsToShow: 3 },
    ];
      
    const companyId = data?.companyData ? data?.companyData?.companyId : '';

    if(courses?.length > 0) {
          return (
            <Box
              style={{
                width:'100%',
                padding:'0px',
                backgroundColor:'#fff',
                height:'221px',
                margin:'19px 0px',
                zIndex:50
              }}
            >
              <Box width="100%" m="auto" position="relative">
                <Box display="flex" flexDirection={'unset'} flexWrap={'unset'} justifyContent={!matches ? "center" : courses?.length <=2 ? 'center' :"space-between"}>
                    <Carousel className={classes.carousel} breakPoints={breakPoints}>
                        {courses.map((item, i) => (
                            <CourseCard key={i} service={item} {...{displayDescription:true,companyId}} />
                        ))
                        }
                    </Carousel>
                </Box>
              </Box>
            </Box>
          );
        };
      
    return null;
}

export default CourseDetail;

const getVideoDuration = (fileUrl) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.src = fileUrl;
  
      video.onloadedmetadata = () => {
        resolve(video.duration);
      };
  
      video.onerror = () => {
        resolve(null); // Handle error cases
      };
    });
};